var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"game-quizz"},[(_vm.current)?_c('Question',{attrs:{"isLast":_vm.isLast,"data":_vm.current},on:{"next":_vm.handleNext,"nextQuestion":_vm.handleNextQuestion,"update-score":_vm.updateScore}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }